import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import { deleteStore } from "actions/draftActions";

class StoreTable extends React.Component {
    constructor() {
        super();
        this.state = {
        };

        this.handleClickDelBtnOnStores = this.handleClickDelBtnOnStores.bind(this);
    }

    handleClickDelBtnOnStores(id, storeNumber) {
        this.props.deleteStore(this.props.draftId, id, storeNumber);
    }

    render() {
        const columns = [
            {
                Header: "Store #",
                accessor: "storeNumber",
                id: "storeNumber",
                minWidth: 100
            },
            {
                Header: "Address",
                accessor: "address",
                id: "address",
                minWidth: 200
            },
            {
                Header: "Province",
                accessor: "province",
                id: "province",
                minWidth: 100
            },
            {
                Header: "City",
                accessor: "city",
                id: "city",
                minWidth: 150
            },
            {
                accessor: "",
                id: "delete",
                Header: "",
                Cell: ({ original }) => (
                    this.props.readOnly
                        ? null
                        : <FontAwesomeIcon
                            icon="times"
                            onClick={() => {
                                this.handleClickDelBtnOnStores(original.id, original.storeNumber);
                            }}
                            style={{ cursor: "pointer" }}
                        />
                ),
                sortable: false,
                filterable: false,
                width: 50,
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }
        ];

        const { draftStores, loading } = this.props;
        return (
            <ReactTable
                data={draftStores}
                headerClassName="table-header"
                columns={columns}
                pageSize={Math.max((draftStores ? draftStores.length : 5), 5)}
                showPagination={false}
                pageSizeOptions={[10, 20, 50, 100]}
                resizable
                className="-striped -highlight"
                loading={loading}
                filterable={false}
                defaultSorted={[
                    {
                        id: "storeId",
                        desc: false
                    }
                ]}
                defaultFilterMethod={filterCaseInsensitive}
                style={{
                    height: "calc((100vh - 450px) / 2)",
                    minHeight: 250
                }}
            />
        );
    }
}

StoreTable.propTypes = {
    draftStores: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    deleteStore: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    draftId: state.draft.draft.id,
    draftStores: state.draft.draft.draftStores,
    loading: state.draft.loading,
});

const mapStateToDispatch = dispatch => ({
    deleteStore: bindActionCreators(deleteStore, dispatch)
});

export default connect(mapStateToProps, mapStateToDispatch)(StoreTable);
